import axios from "axios";

export const BASE_URL = "https://api.pinfang.org.cn";
// export const BASE_URL = "http://127.0.0.1:8100";

// console.log({ BASE_URL });

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 5000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    console.error("error", error);
    // message.error('网络异常')
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    const { data } = response;
    console.log({ data });
    if(data.status === 403) {
      localStorage.clear()
      window.location.reload()
    }

   
    return Promise.resolve(response);
  },
  (error) => {
    console.error("error", error);
    // localStorage.clear()
    //   window.location.reload()
    return Promise.resolve(error);
  }
);

export default function request(
  config
) {
  return new Promise((resolve, reject) => {
    axiosInstance
      .request(config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        resolve(error);
      });
  });
}
